import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { renderFeedbackLoader, Surveys } from 'web-interactives-components/optin/CsatSurvey';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import { makeAsyncComponent } from 'web-interactives-dashboard-ui/utils/makeAsyncUtils';
import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import EmbeddingInfoModal from 'web-interactives-dashboard-ui/components/modals/EmbeddingInfoModal';
import UnpublishModal from 'web-interactives-dashboard-ui/components/modals/UnpublishModal';
import PreviewModal from 'web-interactives-dashboard-ui/components/modals/PreviewModal';
import DetailsPanel from 'web-interactives-dashboard-ui/components/panels/DetailsPanel';
import PersonalizationVariantsModal from 'web-interactives-dashboard-ui/components/modals/PersonalizationVariantsModal';
import { closeModal } from '../actions/ModalActions';
import { ManageAccessPanel } from './manage/ManageAccessPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncDeleteModal = makeAsyncComponent(() => import( /* webpackChunkName: 'delete-modal' */'web-interactives-dashboard-ui/components/modals/DeleteModal'), {
  delay: 0
});
const AsyncCloneModal = makeAsyncComponent(() => import( /* webpackChunkName: 'clone-modal' */'web-interactives-dashboard-ui/components/modals/CloneModal'), {
  delay: 0
});
const AsyncArchiveModal = makeAsyncComponent(() => import( /* webpackChunkName: 'archive-modal' */'web-interactives-dashboard-ui/components/modals/ArchiveModal'), {
  delay: 0
});
const AsyncRunAbTestModal = makeAsyncComponent(() => import( /* webpackChunkName: 'run-ab-test-modal' */'web-interactives-dashboard-ui/components/modals/RunAbTestModal'), {
  delay: 0
});
const AsyncPickAbTestWinnerModal = makeAsyncComponent(() => import( /* webpackChunkName: 'pick-ab-test-winner-modal' */'web-interactives-dashboard-ui/components/modals/PickAbTestWinnerModal'), {
  delay: 0
});
const AsyncGenerateWithAIWizard = makeAsyncComponent(() => import( /* webpackChunkName: 'generate-with-ai-wizard' */'web-interactives-dashboard-ui/components/ai-generation/GenerateWithAIWizard'), {
  delay: 0
});
const DeleteModal = withModalProps(AsyncDeleteModal, MODAL_TYPES.DELETE);
const CloneModal = withModalProps(AsyncCloneModal, MODAL_TYPES.CLONE);
const ArchiveModal = withModalProps(AsyncArchiveModal, MODAL_TYPES.ARCHIVE);
const RunAbTestModal = withModalProps(AsyncRunAbTestModal, MODAL_TYPES.RUN_AB_TEST);
const PickAbTestWinnerModal = withModalProps(AsyncPickAbTestWinnerModal, MODAL_TYPES.PICK_AB_TEST_WINNER);
const GenerateWithAIWizard = withModalProps(AsyncGenerateWithAIWizard, MODAL_TYPES.GENERATE_WITH_AI);
export const ModalsContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isInitialMount = useRef(true);

  /*
    Closing modals on route change, skipping on mount for tests sake
  */
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      dispatch(closeModal());
    }
  }, [location, dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PickAbTestWinnerModal, {}), /*#__PURE__*/_jsx(RunAbTestModal, {}), /*#__PURE__*/_jsx(DeleteModal, {}), /*#__PURE__*/_jsx(CloneModal, {}), /*#__PURE__*/_jsx(ArchiveModal, {}), /*#__PURE__*/_jsx(UnpublishModal, {}), /*#__PURE__*/_jsx(PreviewModal, {}), /*#__PURE__*/_jsx(EmbeddingInfoModal, {}), /*#__PURE__*/_jsx(DetailsPanel, {}), /*#__PURE__*/_jsx(ManageAccessPanel, {}), /*#__PURE__*/_jsx(GenerateWithAIWizard, {}), /*#__PURE__*/_jsx(PersonalizationVariantsModal, {}), renderFeedbackLoader(Surveys.MVP_BETA)]
  });
};
export default ModalsContainer;